const getReducerKeyValue = (reduxStore, reducerKey, key) =>
  reduxStore.getRState(reducerKey)[key.toString()]

const setReducerKeyValue = (reduxStore, reducerKey, key, value) => {
  reduxStore.setRState(reducerKey, { [key]: value })
  return true
}

const defineProxyGetSet = (obj, reduxStore, reducerKey, key) => {
  Object.defineProperty(obj, key, {
    get: () => getReducerKeyValue(reduxStore, reducerKey, key),
    set: value => setReducerKeyValue(reduxStore, reducerKey, key, value)
  })
}

export const simulateProxy = (reduxStore, reducerKey, initialState) =>
  Object.keys(initialState).reduce((obj, key) => {
    defineProxyGetSet(obj, reduxStore, reducerKey, key)
    return obj
  }, {})

const getProxyHandler = reducerKey => {
  return {
    get: (reduxStore, key) => getReducerKeyValue(reduxStore, reducerKey, key),
    set: (reduxStore, key, value) => setReducerKeyValue(reduxStore, reducerKey, key, value)
  }
}

export default (reduxStore, reducerKey, initialState) => {
  if (typeof Proxy !== 'undefined') {
    return new Proxy(reduxStore, getProxyHandler(reducerKey))
  }
  return simulateProxy(reduxStore, reducerKey, initialState)
}
